import {Component, OnDestroy, OnInit} from '@angular/core';
import {Store} from '@ngrx/store';
import * as fromScheduleRotationActions from '../../store/schedule-rotation/schedule-rotation.actions';
import {IScheduleRotation} from '@signal/asp-data-commons/lib/interfaces/employee';
import {Department, WeekDays} from '@signal/asp-data-commons';
import {ScheduleRotationState} from '../../store/schedule-rotation/schedule-rotation.reducer';
import * as fromScheduleRotationSelectors from '../../store/schedule-rotation/schedule-rotation.selectors';
import {Observable,Subject} from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import {AddItemComponent} from '../../shared/components/add-item/add-item.component';
import {ActivatedRoute} from '@angular/router';
import {TeamState} from '../../store/team/team.reducer';
import {LoadTeams} from '../../store/team/team.actions';
import {selectSettings} from 'src/app/modules/store/settings/settings.selectors';
import { SettingsState } from 'src/app/modules/store/settings/settings.reducer';
import {v4 as uuid} from 'uuid';
import { selectTeams } from '../../store/team/team.selectors';
import { INavigateAway } from '../../shared/guards/NavigationGuard';
import { ConfirmDialogComponent } from '../../shared/components/confirm-dialog/confirm-dialog.component';
import { exitConfig, unsubscribeSubscriptions } from '../../shared/services/util.service';
import { SubscriptionList } from '../../shared/models/asp.types';
import { LoadSettings } from '../../store/settings/settings.actions';
import { HoursOfOperation } from '../../shared/models/settings.model';

@Component({
  selector: 'app-service-schedule',
  templateUrl: './service-schedule.component.html',
  styleUrls: ['./service-schedule.component.scss']
})
export class ServiceScheduleComponent implements OnInit,INavigateAway, OnDestroy {
  scheduleId: string;
  isEditMode: boolean;
  department = Department.SERVICE;
  scheduleRotations$: Observable<IScheduleRotation[]>;
  scheduleRotationsLoading$: Observable<boolean>;
  teams;
  team$: Observable<any>;
  valuesNotChanged=true;
  saveClicked=false;
  closedDays: Set<string> = new Set<string>();
  private subs: SubscriptionList = {};

  constructor(private readonly dialog: MatDialog,
              private readonly activatedRoute: ActivatedRoute,
              private readonly teamState: Store<TeamState>,
              private readonly settingsState: Store<SettingsState>,
              private readonly scheduleRotationState: Store<ScheduleRotationState>) {
  }

  ngOnInit(): void {
    this.setupStore();
    // Generated by Copilot- Start
    this.teamState.dispatch(new LoadTeams());
    this.settingsState.dispatch(new LoadSettings({ department: this.department }));
    this.subs.route = this.activatedRoute.queryParams.subscribe(params => {
      this.scheduleId = params.id;
      this.isEditMode = !!this.scheduleId;
    });
    this.subs.settings = this.settingsState.select(selectSettings).subscribe(settings => {
      this.closedDays = this.getClosedDays(settings?.time?.hoursOfOperation);
    });
    this.team$ = this.teamState.select(selectTeams);
    this.subs.team = this.team$.subscribe(item => {
      this.teams = (item || []).map((member: any) => ({id: member.id, name: member.name}));
    });
    // Generated by Copilot- End
  }

   //checks if navigation is allowed 
 canExit():Observable<boolean> { 
  const result = new Subject<boolean>();
  const dialogRef = this.dialog.open(ConfirmDialogComponent,exitConfig
    );
  this.subs.dialogRef = dialogRef.afterClosed().subscribe(event => {
    if (event.action === 'confirm') {
      this.saveClicked=true
      result.next(true);
      result.complete();
    }
    else{
      result.next(true);
      result.complete();
    }
  });
  return result.asObservable(); 
};

 // returns if the forms are edited
 formsNotEdited()
 {
   return this.valuesNotChanged; 
 }

  //valuesChanged
  valuesChanged(event)
  {
    this.valuesNotChanged=event;
  }
  
  onAddNewSchedule() {
    const dialogRef = this.dialog.open(AddItemComponent, {
      width: '25rem',
      height: '18.625rem',
      panelClass: 'asp-modal-container',
      disableClose:true,
      data: {isEditMode: false, title: 'scheduleRotation.addNewSchedule', type: 'schedule',clicked:true},
    });
    this.subs.dialogRefSchedule = dialogRef.afterClosed().subscribe(event => {
      if (event.action === 'confirm') {
        // Generated by Copilot- Start
        const shiftId = uuid();
        const buildDefaultDetails = () => (this.teams || []).map(member => ({ id: member.id, name: member.name }));
        const buildDayShift = (day: WeekDays) => [{
          shiftId,
          shiftName: 'Open To Close',
          detail: this.closedDays.has(this.normalizeDay(day)) ? [] : buildDefaultDetails()
        }];
        const week = {
          [WeekDays.MONDAY]: buildDayShift(WeekDays.MONDAY),
          [WeekDays.TUESDAY]: buildDayShift(WeekDays.TUESDAY),
          [WeekDays.WEDNESDAY]: buildDayShift(WeekDays.WEDNESDAY),
          [WeekDays.THURSDAY]: buildDayShift(WeekDays.THURSDAY),
          [WeekDays.FRIDAY]: buildDayShift(WeekDays.FRIDAY),
          [WeekDays.SATURDAY]: buildDayShift(WeekDays.SATURDAY),
          [WeekDays.SUNDAY]: buildDayShift(WeekDays.SUNDAY),
        };
        // Generated by Copilot- End
        const payload : IScheduleRotation = {
          id : uuid(),
          by : "team",
          department : this.department,
          name : event.data.name,
          rotation : [week],
          // Generated by Copilot- Start
          shifts: [],
          startDate : ""
        }
        payload.shifts.push({
          id : shiftId,
          fromTime : "Operational hours",
          name : "Open To Close",
          toTime : "Operational hours"
        })
        // Generated by Copilot- End
        this.scheduleRotationState.dispatch(new fromScheduleRotationActions.AddScheduleRotation({
          department: this.department, name: event.data.name, payload: payload
        }));
      }
    });
  }

  private setupStore() {
    /* Store actions dispatchers */
    this.dispatchActions();
    this.scheduleRotationsLoading$ = this.scheduleRotationState.select(fromScheduleRotationSelectors.selectScheduleRotationLoading, {
      department: Department.SERVICE
    });
    this.scheduleRotations$ = this.scheduleRotationState.select(fromScheduleRotationSelectors.selectScheduleRotationsByStartDate, {
      department: Department.SERVICE,
      id: undefined
    });
  }

  private dispatchActions() {
    this.scheduleRotationState.dispatch(new fromScheduleRotationActions.LoadScheduleRotation({department: Department.SERVICE}));
  }

  private getClosedDays(hoursOfOperation: HoursOfOperation[] = []): Set<string> {
    return new Set((hoursOfOperation || [])
      .filter(entry => (entry?.operation || '').toLowerCase() === 'closed')
      .map(entry => this.normalizeDay(entry?.day))
      .filter(day => !!day));
  }

  private normalizeDay(day: string): string {
    const normalized = (day || '').toLowerCase();
    // Generated by Copilot- Start
    // Map abbreviated day names (from hoursOfOperation) to full names (matching WeekDays enum)
    const abbrevToFullDay: { [key: string]: string } = {
      'mon': 'monday',
      'tue': 'tuesday',
      'wed': 'wednesday',
      'thu': 'thursday',
      'fri': 'friday',
      'sat': 'saturday',
      'sun': 'sunday'
    };
    return abbrevToFullDay[normalized] || normalized;
    // Generated by Copilot- End
  }

  ngOnDestroy(){
    unsubscribeSubscriptions(this.subs);
  }

}

